export default function TestimonialSection() {
  return (
    <section className="relative w-full bg-background-100 py-20 md:py-28">
      <div className="w-full max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-center">
          {/* Left - Testimonial */}
          <div className="lg:w-[60%] order-2 lg:order-1">
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-accent-700 uppercase tracking-wider mb-8">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              Avis Client
            </span>

            <blockquote className="text-2xl md:text-4xl font-heading font-medium text-foreground-950 leading-snug mb-8 italic">
              &ldquo;Hipobuy Spreadsheet a transformé notre façon de gérer les stocks.
              L&apos;interface intuitive et la rapidité d&apos;analyse sont incomparables
              en 2026.&rdquo;
            </blockquote>

            <div className="flex items-center gap-4">
              <div className="w-11 h-11 rounded-full bg-accent-100 flex items-center justify-center">
                <span className="text-accent-600 font-heading font-bold text-lg">MD</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground-900">Marie Dubois</p>
                <div className="flex items-center gap-1.5 mt-0.5">
                  <div className="flex items-center gap-0.5">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className="w-3.5 h-3.5 flex items-center justify-center text-accent-500">
                        <i className="ri-star-fill text-xs"></i>
                      </span>
                    ))}
                  </div>
                  <span className="text-xs text-foreground-400 ml-1">Google Reviews</span>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Portrait */}
          <div className="lg:w-[40%] order-1 lg:order-2 flex justify-center">
            <div className="relative w-64 h-80 md:w-72 md:h-96 rounded-3xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20confident%20European%20businesswoman%20portrait%20elegant%20blazer%20warm%20genuine%20smile%20natural%20daylight%20clean%20white%20studio%20background%20modern%20corporate%20headshot%20photography%20high%20quality%20editorial%20style%20warm%20neutral%20tones%20sophisticated%20look&width=600&height=800&seq=testimonial-v3-new&orientation=portrait"
                alt="Marie Dubois - Avis Hipobuy Spreadsheet"
                title="Marie Dubois - Témoignage client Hipobuy Spreadsheet"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}